'use client';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

interface GenerationModalProps {
  isOpen: boolean;
  onClose: () => void;
  isGenerating: boolean;
  selectedGenerationType: string | null;
  fileName: string;
  onFileNameChange: (name: string) => void;
  onConfirmGeneration: () => void;
}

export function GenerationModal({
  isOpen,
  onClose,
  isGenerating,
  selectedGenerationType,
  fileName,
  onFileNameChange,
  onConfirmGeneration,
}: GenerationModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-900">
            Generate {selectedGenerationType || 'Document'}
          </DialogTitle>
        </DialogHeader>

        {isGenerating ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-2 text-gray-600">Generating...</span>
          </div>
        ) : (
          <div className="py-4 space-y-4">
            <div>
              <label
                htmlFor="file-name"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                File Name
              </label>
              <Input
                id="file-name"
                value={fileName}
                onChange={(e) => onFileNameChange(e.target.value)}
                placeholder="Enter file name"
                className="w-full"
              />
            </div>
          </div>
        )}

        <DialogFooter className="flex-row justify-end space-x-2 pt-4">
          <Button variant="outline" onClick={onClose} className="px-4 py-2">
            Cancel
          </Button>
          <Button
            onClick={onConfirmGeneration}
            disabled={!fileName.trim() || isGenerating}
            className={`px-4 py-2 ${
              fileName.trim() && !isGenerating
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            {isGenerating ? 'Generating...' : 'Generate'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
